import React, {ComponentProps, FC} from 'react';

import {Colors, Skeleton, Text} from '@optimaxdev/design-system';
import {Icon, Attention, ApproveCircle} from '@optimaxdev/icons';

import classNames from 'classnames';

import s from './statusBlock.scss';

export type PropsType = {isVerification: boolean; isFetching?: boolean};

const getUIProps = (
    isMobile: boolean,
    isVerification: boolean,
): {
    textProps: ComponentProps<typeof Text>;
    iconProps: Partial<ComponentProps<typeof Icon>>;
} => {
    return {
        iconProps: {
            strokeWidth: 2,
            width: isMobile ? '12px' : '14px',
        },

        textProps: {
            as: 'p',
            className: classNames(s.titlePrescription, {[s.mobile]: isMobile}),
            color: isVerification ? Colors.jade : Colors.orangeRoughy,
            lineHeight: isMobile ? '14px' : '18px',
            medium: true,
            size: isMobile ? '12px' : '14px',
        },
    };
};

/**
 * Status block for contacts item on TYP
 */
export const StatusBlock: FC<PropsType> = ({isFetching = false, isVerification}) => {
    const isMobile = __BUILD_TYPE__ === 'mobile';

    const {iconProps, textProps} = getUIProps(isMobile, isVerification);

    if (isFetching)
        return <Skeleton height={isMobile ? '14px' : '18px'} radius="4px" width="100%" />;

    return (
        <>
            <Text {...textProps}>
                <Icon icon={isVerification ? ApproveCircle : Attention} {...iconProps} />
                {isVerification ? ' Verification in process' : ' This item requires attention'}
            </Text>
        </>
    );
};
